import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ContextMenuElement } from '@base/classes/BaseClasses';
import { BaseComponent } from '@base/component/BaseComponent';
import { ServiceBagService } from '@base/component/ServiceBag';
import { BaseState } from '@base/entities/BaseEntities';
import { BottomSheetContentParams, BottomSheetContextMenuParams, BottomSheetListParams, BottomSheetService } from '@core/framework/bottom-sheet.service';
import { ScreenService } from '@core/framework/screen.service';
import { DemoButtonsComponent } from '@ui/demo/components/buttons/demo-buttons.component';
import { Subscription } from 'rxjs';

class State extends BaseState {
    ListItems: any[] = [];
    ContextMenu: ContextMenuElement[] = [];
}

@Component({
    selector: 'app-demo-bottom-sheets',
    templateUrl: './demo-bottom-sheets.component.html',
    styleUrls: ['../../styles/demo-styles.scss']
})
export class DemoBottomSheetsComponent extends BaseComponent<State> {

    @ViewChild('template') template: TemplateRef<any>;

    private bottomListSubscription: Subscription;
    
    constructor(A: ServiceBagService, public screen: ScreenService, private bottomSheetService: BottomSheetService) {
        super(A, 'DemoBottomSheetsComponent', State);
    }

    protected override OnInitComponent() {
        this.State.ListItems = this.GetListItems();
        this.State.ContextMenu = this.GetContextMenu();
    }
    
    protected override OnDestroyComponent() {
        super.OnDestroyComponent();
        
        this.bottomListSubscription?.unsubscribe();
    }
    
    public OnShowComponentClicked() {
        const contentParams = new BottomSheetContentParams();
        contentParams.Content = DemoButtonsComponent;
        contentParams.Title = 'Component Example';
        this.bottomSheetService.Show(contentParams);
    }
    
    public OnShowTemplateClicked() {
        const contentParams = new BottomSheetContentParams();
        contentParams.Content = this.template;
        contentParams.Title = 'Template Example';
        this.bottomSheetService.Show(contentParams);
    }
    
    public OnShowListClicked() {
        const listParams = new BottomSheetListParams();
        listParams.Title = 'Items';
        listParams.DataSource = this.State.ListItems;
        listParams.OnCompleted = (result) => console.log(result);

        this.bottomSheetService.ShowList(listParams);
    }

    public OnShowContextMenuClicked() {
        const menuParams = new BottomSheetContextMenuParams();
        menuParams.Title = 'Context Menu Example';
        menuParams.Items = this.State.ContextMenu;
        this.bottomSheetService.ShowContextMenu(menuParams);
    }
    
    public GetContextMenu() : ContextMenuElement[] {
        return [
            {
                text: 'Add',
                icon: 'add',
                onClick: () => console.log('Context Menu - add button clicked.')
            },
            {
                text: 'Edit',
                icon: 'edit',
                onClick: () => console.log('Context Menu - edit button clicked.')
            }
        ];
    }
    
    public GetListItems() {
        return [
            {
                EntryID: 1,
                Name: 'Clock',
                Icon: 'mdi mdi-clock-outline'
            },
            {
                EntryID: 2,
                Name: 'Map',
                Icon: 'mdi mdi-map-outline'
            },
            {
                EntryID: 3,
                Name: 'Agenda',
                Icon: 'mdi mdi-view-agenda-outline'
            }
        ];
    }
}
